import { useRoutes } from 'react-router-dom';
import routes from './routes/Routes';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AuthProvider } from './contexts/AuthContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#203064',
    },
  },
});

const App = () => {
  console.log('App component rendering...');
  const content = useRoutes(routes);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        {content}
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
